import { render, staticRenderFns } from "./ClienteModalEdicion.vue?vue&type=template&id=78c9fd70&scoped=true&"
import script from "./ClienteModalEdicion.vue?vue&type=script&lang=ts&"
export * from "./ClienteModalEdicion.vue?vue&type=script&lang=ts&"
import style0 from "./ClienteModalEdicion.vue?vue&type=style&index=0&id=78c9fd70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c9fd70",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('78c9fd70', component.options)
    } else {
      api.reload('78c9fd70', component.options)
    }
    module.hot.accept("./ClienteModalEdicion.vue?vue&type=template&id=78c9fd70&scoped=true&", function () {
      api.rerender('78c9fd70', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/plataforma/ClienteModalEdicion.vue"
export default component.exports